import { render } from "./BasicDropdown.vue?vue&type=template&id=3c061bfc&scoped=true"
import script from "./BasicDropdown.vue?vue&type=script&lang=js"
export * from "./BasicDropdown.vue?vue&type=script&lang=js"

import "./BasicDropdown.vue?vue&type=style&index=0&id=3c061bfc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c061bfc"

export default script